var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("svg", {
    staticClass: "hub-icon",
    attrs: {
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true"
    }
  }, [_vm.name === "server" ? [_c("rect", {
    attrs: {
      x: "3",
      y: "4",
      width: "18",
      height: "6",
      rx: "2"
    }
  }), _c("rect", {
    attrs: {
      x: "3",
      y: "14",
      width: "18",
      height: "6",
      rx: "2"
    }
  }), _c("path", {
    attrs: {
      d: "M7 7h.01M7 17h.01M11 7h6M11 17h6"
    }
  })] : _vm.name === "wallet" ? [_c("path", {
    attrs: {
      d: "M4 7.5A2.5 2.5 0 0 1 6.5 5H19v14H6.5A2.5 2.5 0 0 1 4 16.5v-9Z"
    }
  }), _c("path", {
    attrs: {
      d: "M4 8h15M15 11h6v5h-6a2.5 2.5 0 0 1 0-5Z"
    }
  })] : _vm.name === "shield" ? [_c("path", {
    attrs: {
      d: "M12 3 4.5 6v5.2c0 4.6 3.2 8 7.5 9.8 4.3-1.8 7.5-5.2 7.5-9.8V6L12 3Z"
    }
  }), _c("path", {
    attrs: {
      d: "m8.5 12 2.2 2.2 4.8-5"
    }
  })] : _vm.name === "checklist" ? [_c("rect", {
    attrs: {
      x: "5",
      y: "3",
      width: "14",
      height: "18",
      rx: "2"
    }
  }), _c("path", {
    attrs: {
      d: "m8 8 1.3 1.3L12 6.5M13.5 9H16M8 14l1.3 1.3 2.7-2.8M13.5 15H16"
    }
  })] : _vm.name === "headset" ? [_c("path", {
    attrs: {
      d: "M4 13v-1a8 8 0 0 1 16 0v1M4 13h3v6H5a1 1 0 0 1-1-1v-5ZM20 13h-3v6h2a1 1 0 0 0 1-1v-5Z"
    }
  }), _c("path", {
    attrs: {
      d: "M17 19c0 1.1-1.8 2-4 2h-1"
    }
  })] : _vm.name === "layers" ? [_c("path", {
    attrs: {
      d: "m12 3 9 5-9 5-9-5 9-5Z"
    }
  }), _c("path", {
    attrs: {
      d: "m3 12 9 5 9-5M3 16l9 5 9-5"
    }
  })] : _vm.name === "app" ? [_c("rect", {
    attrs: {
      x: "4",
      y: "4",
      width: "6",
      height: "6",
      rx: "1"
    }
  }), _c("rect", {
    attrs: {
      x: "14",
      y: "4",
      width: "6",
      height: "6",
      rx: "1"
    }
  }), _c("rect", {
    attrs: {
      x: "4",
      y: "14",
      width: "6",
      height: "6",
      rx: "1"
    }
  }), _c("rect", {
    attrs: {
      x: "14",
      y: "14",
      width: "6",
      height: "6",
      rx: "1"
    }
  })] : _vm.name === "check" ? [_c("path", {
    attrs: {
      d: "m5 12 4 4L19 6"
    }
  })] : [_c("path", {
    attrs: {
      d: "M5 12h14M14 7l5 5-5 5"
    }
  })]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };